// extracted by mini-css-extract-plugin
export default {"table":"VendorInvoice_table__YxQOJ","secondary":"VendorInvoice_secondary__YqFXV","divider":"VendorInvoice_divider__BfyYs"};